/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { listProjects } from "services/projectsService";
import { useLanguage } from "LanguageContext";
import AutocompleteProject from "../../CommonUi/Autocomplete/AutocompleteProject";
import Autocomplete from "../../CommonUi/Autocomplete/Autocomplete";
interface AdvertiserSearchProps {
  setAdvertiser: (advertiser: string) => void;
  focuseNext: () => void;
  advertiser?: string;
  advertiserLable?: string;
  advertiserPlaceholder?: string;
  setChangeName?:(val: any) => void;
  pageName?: string;
  advertiserLabel?:string;
}

export default function AdvertiserSearch(
  props: Readonly<AdvertiserSearchProps>
) {

  const { t } = useLanguage();
  const [advertisers, setAdvertisers] = useState<string[]>([]);

  function fetchAdvertisers() {
    listProjects({ sortingColumns: {} }).then((res: any) => {
      const advertisersList = res.results.map((result: any) => result.advertiser);
      const updatedData = Array.from(new Set(advertisersList)).sort((a:any, b: any) => a.localeCompare(b)) || [];
      setAdvertisers(updatedData as string[]);
    });
  }
  useEffect(() => {  
    fetchAdvertisers();
  }, []);
  
  return (
    <>
      {!props?.pageName && (
        <AutocompleteProject
          data={advertisers}
          setAutocompleteValue={props.setAdvertiser}
          autocompleteLable={props.advertiserLabel}
          autocompletePlaceholder={props.advertiserPlaceholder || ""}
          autocompleteValue={props.advertiser}
          addnewButtonPrefix={t("project_add_new")}
          focuseNext={props.focuseNext}
          props={{
            name: "AdvertiserName",
          }}
          messageUpdate={props.setChangeName}
        />
      )}
       {props?.pageName === 'NewProject' && (
            <Autocomplete
            data={advertisers}
            setAutocompleteValue={props?.setAdvertiser}
            autocompleteLable={props?.advertiserLable || t("alertDialog_add_project_label_advertiser")}
            autocompletePlaceholder={props?.advertiserPlaceholder || ""}
            autocompleteValue={props?.advertiser}
            addnewButtonPrefix={t("project_add_new")}
            focuseNext={props.focuseNext}
            props={{
              name: "AdvertiserName",
            }}
          />
      )}
    </>
  )
}
